type AvatarType = {
    image?: string
    name: string
    size?: number
}

const Avatar = ({ image, name, size = 8 }: AvatarType) => {
    const firstLetter = name.charAt(0).toUpperCase()

    return (
        <>
            {image ? (
                <img src={image} alt={name} className={`rounded-full w-${size} h-${size} border-2 border-brand-500`} />
            ) : (
                <span
                    className={`rounded-full w-${size} h-${size} bg-gray-200 dark:bg-gray-700 dark:text-white flex items-center justify-center font-bold`}
                >
                    {firstLetter}
                </span>
            )}
        </>
    )
}

export default Avatar
